<template>

    <v-card height="58" flat class="mb-1 kim-card secondary-card py-0">

        <v-card-text class="py-1">
          <v-row justify="center" align="center">
            <v-col cols="2" md="1">
              <v-avatar size="40">
                <img alt="avatar" :src="avatar" />
              </v-avatar>
            </v-col>
            <v-col cols="7" md="9">
              <div class="ml-2">{{label}}: </div>
              <div>
                <span class="ml-2 subtitle font-weight-bold">{{client.firstName}} {{client.lastName}}</span>
              </div>
            </v-col>
            <v-col cols="3" md="2" class="text-right">
              <v-btn @click="$emit('remove')" color="error" fab small text>
                <v-icon>fa-trash</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-card-text>

    </v-card>

</template>
<script>

    import {getLabel} from '@/utils/Institution'
    import {getFakeAvatar} from '@/utils/Common'

    export default{
        props:{
            removeBtn:{
                type: Boolean,
                default: true
            },
            client: {
                type: Object,
                required: true
            },
            internal: {
                type: Boolean,
                default: false
            },
            label:{
                type: String,
                default: getLabel('commons.client.singular')
            }
        },
        computed: {
            avatar(){
                var vm = this
                return vm.client.avatar || getFakeAvatar(vm.client.gender)
            }
        },
        methods:{
            getLabel
        }
    }
</script>
